import { FeatureFlag } from '@ps/web-core-enums';
import type { EventId } from '@ps/web-sports-api-types';
import React from 'react';
import { useSelector } from 'react-redux';

import useFeature from '@swf/core/hooks/useFeature';
import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';
import { isScoreboardSupportedMarketLevel } from '@swf/sports/utils/isScoreboardSupportedMarketLevel';

import type { Props as DefaultEventStatusProps } from './components/DefaultEventStatus/DefaultEventStatus';
import DefaultEventStatus from './components/DefaultEventStatus/DefaultEventStatus';
import ScoreboardInPlayStatus from './components/InPlayStatus/ScoreboardInPlayStatus';

export interface Props extends DefaultEventStatusProps {
  eventId?: EventId;
}

const EventStatus: React.FC<Props> = (props) => {
  const scoreboardsHasError = useSelector(select.scoreboards.hasNetworkError);
  const scoreboardData = useSelector((rootState: RootState) =>
    select.scoreboards.eventScoreboard(rootState, props.eventId ?? Infinity)
  );
  const isScoreboardsEnabled = useFeature(FeatureFlag.ISPScoreboards);

  if (
    isScoreboardsEnabled &&
    scoreboardData &&
    !scoreboardsHasError &&
    isScoreboardSupportedMarketLevel(props.marketLevels)
  ) {
    return <ScoreboardInPlayStatus scoreboardData={scoreboardData} />;
  }

  return (
    <DefaultEventStatus
      {...props}
      timeFormat={props.timeFormat || 'SHORT'}
      size={props.size || 'XSmall'}
    />
  );
};

export default EventStatus;
